/**
 * Placeholder for section content during Day 2. Day 3+ replaces these with
 * real implementations (Conversations table, Leads table, etc.).
 */
export function SectionPlaceholder({
  title,
  hint,
}: {
  title: string;
  hint: string;
}) {
  return (
    <div>
      <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
      <div className="mt-6 rounded-xl border border-dashed border-slate-300 bg-white p-10 text-center">
        <p className="text-slate-600">{hint}</p>
        <p className="mt-2 text-xs text-slate-400">
          Wired up on Day 3 of the dashboard build.
        </p>
      </div>
    </div>
  );
}
